/* eslint eol-last: ["error", "never"] */
export default {
    loading: false,
    ofertaslist: true,
    ofertasadd: false,
    ofertas: [],
    ofertantes: [],
    documentos: [],
}